import angular from 'angular';
import cookies from 'angular-cookies';

import Controller from "./controllers/controller";
import VideosController from "./controllers/videos";
import CommentsController from "./controllers/comments";
import FlyingController from "./controllers/flying";
import PostsController from "./controllers/posts";
import LoginController from "./controllers/login";
import BunnyController from "./controllers/bunny";
import OutStreamController from "./controllers/outStream";

import ngBackground from "./directives/background"
import ngTicker from './directives/ticker';
import ngPreview from "./directives/preview";
import ngReplace from "./directives/replace";
import ngDrop  from "./directives/drop";
import ngRoll from "./directives/roll";
import ngSearch from "./directives/search";
import ngRange from "./directives/range";
import ngPopUnder from "./directives/pop-under";
import ngPopChrome from "./directives/pop-chrome";
import ngAnalytics from "./directives/analytics";
import ngNoFlicker from "./directives/noflicker";
import ngIntersects from "./directives/intersects";
import ngMoreLess from "./directives/more-less";
import ngVideoItem from "./directives/video-item";
import ngVideoRoll from "./directives/video-roll";
import ngVideoPostRoll from "./directives/video-post-roll";
import ngVideoPlayer from "./directives/video-player";
import ngVideoReality from "./directives/video-reality";
import ngHeader from "./directives/header";
import ngHeaderLogin from "./directives/header-login";
import ngLazy from "./directives/lazy";
import ngFlying from "./directives/flying";
import ngRecaptcha from "./directives/recaptcha";
import ngGoogleButton from "./directives/google-button";
import ngVideoOutStream from "./directives/video-out-stream";
import ngFollow from "./directives/follow";
import ngBannerChoice from "./directives/banner-choice";
import ngSidebarScroll from "./directives/sidebar-scroll";
import ngPillsScroll from "./directives/pills-scroll";

// Services
import $modules from "./services/modules";
import $device from "./services/device";
import $lazy from "./services/lazy";
import $lazyScripts from "./services/lazy-scripts";
import $request from "./services/request";
import $google from "./services/google";
import $hotJar from "./services/hotjar";

// Filters
import $trust from "./filters/trust";
import $objects from "./factories/objects";
import ngRemove from "./directives/remove";



(function(angular) {
let app = angular.module('pd', [cookies]);
    app.config(['$locationProvider', '$sceDelegateProvider', '$httpProvider', function ($locationProvider, $sceDelegateProvider, $httpProvider) {
        $locationProvider.hashPrefix("");
        //$locationProvider.html5Mode(true);
        $sceDelegateProvider.trustedResourceUrlList(['**']);
      //  $httpProvider.defaults.withCredentials = true;
    }]);

    app.filter("trust", $trust);
    app.factory("$objects", $objects);

    app.service('$modules', $modules );
    app.service('$lazy', $lazy);
    app.service('$lazyScripts', $lazyScripts);
    app.service('$device', $device);
    app.service('$request', $request);
    app.service('$google', $google);
    app.service('$hotJar', $hotJar);

    app.directive('ngBackground',  ngBackground );
    app.directive('ngTicker', ngTicker );
    app.directive('ngPreview', ngPreview);
    app.directive('ngDrop', ngDrop);
    app.directive('ngRoll', ngRoll);
    app.directive('ngReplace', ngReplace);
    app.directive('ngSearch', ngSearch);
    app.directive('ngRange', ngRange);
    app.directive('ngPopUnder', ngPopUnder);
    app.directive('ngPopChrome', ngPopChrome);
    app.directive('ngAnalytics', ngAnalytics);
    app.directive('ngNoFlicker', ngNoFlicker);
    app.directive('ngIntersects', ngIntersects);
    app.directive('ngMoreLess', ngMoreLess);
    app.directive('ngHeader', ngHeader);
    app.directive('ngHeaderLogin', ngHeaderLogin);
    app.directive('ngRemove', ngRemove);
    app.directive('ngVideoItem', ngVideoItem);
    app.directive('ngVideoRoll', ngVideoRoll);
    app.directive('ngVideoPostRoll', ngVideoPostRoll);
    app.directive('ngVideoPlayer', ngVideoPlayer);
    app.directive('ngVideoReality', ngVideoReality);
    app.directive('ngLazy', ngLazy);
    app.directive('ngFlying', ngFlying);
    app.directive('ngRecaptcha', ngRecaptcha);
    app.directive('ngGoogleButton', ngGoogleButton);
    app.directive('ngVideoOutStream', ngVideoOutStream);
    app.directive('ngFollow', ngFollow);
    app.directive('ngBannerChoice', ngBannerChoice);
    app.directive('ngSidebarScroll', ngSidebarScroll);
    app.directive('ngPillsScroll', ngPillsScroll);

    app.controller('controller', Controller);
    app.controller('videos', VideosController);
    app.controller('comments', CommentsController);
    app.controller('flying', FlyingController);
    app.controller('posts', PostsController);

    app.controller('login', LoginController);
    app.controller('bunny', BunnyController);
    app.controller('outStream', OutStreamController);

})(angular);
